import { PIXI } from '@colonist/pixi';
// @ts-expect-error missing types
import FPS from 'yy-fps';
import { UIGameResponsiveController } from './UIGameResponsiveController.ts';
import { StorageWrapper } from '../StorageWrapper.ts';
import { UICanvasController } from '../ui_canvas_engine/UICanvasController.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { isAffectedBySafariWebGlBug, isAffectedByFirefoxWebGlBug } from '../ui_utils/ClientUtils.ts';
import { TimeUtils } from '@colonist/utils';
import { GameColor } from '@colonist/ui-game';
import * as Sentry from '@sentry/browser';
export class UIGameCanvasController extends UICanvasController {
    static setInitialValues() {
        const permissibleValuesKeyboardShortcuts = [
            false,
            true
        ];
        const keyboardShortcuts = StorageWrapper.getKeyboardShortcuts();
        if (keyboardShortcuts == undefined || !permissibleValuesKeyboardShortcuts.includes(keyboardShortcuts)) {
            StorageWrapper.setKeyboardShortcuts(true);
        }
        const permissibleValuesAntialias = [
            false,
            true
        ];
        const antialias = StorageWrapper.getAntialias();
        if (antialias == undefined || !permissibleValuesAntialias.includes(antialias)) {
            StorageWrapper.setAntialias(window.devicePixelRatio * window.innerWidth <= 2000);
        }
        const permissibleValuesResolution = [
            0.5,
            1,
            1.5,
            2
        ];
        const resolution = StorageWrapper.getResolution();
        if (resolution == undefined || !permissibleValuesResolution.includes(resolution)) {
            const defaultResolution = Math.min(2, window.devicePixelRatio);
            StorageWrapper.setResolution(defaultResolution);
        }
        const permissibleValuesAnimation = [
            false,
            true
        ];
        const animationStatus = StorageWrapper.getAnimation();
        if (animationStatus == undefined || !permissibleValuesAnimation.includes(animationStatus)) {
            StorageWrapper.setAnimation(true);
        }
    }
    createPixiApplication() {
        var _StorageWrapper_getAntialias;
        const antialias = (_StorageWrapper_getAntialias = StorageWrapper.getAntialias()) !== null && _StorageWrapper_getAntialias !== void 0 ? _StorageWrapper_getAntialias : false;
        const resolution = UIGameCanvasController.getResolution();
        const powerPref = StorageWrapper.getPowerPreference();
        const options = {
            antialias: isAffectedBySafariWebGlBug() || isAffectedByFirefoxWebGlBug() ? false : antialias,
            resolution: resolution,
            backgroundColor: GameColor.getColorHexValue(GameColor.Color.Sea),
            powerPreference: powerPref,
            hello: false
        };
        super.createPIXIApplication(options);
        this.createTooltipPixiApplication(options);
        this.fps = new FPS();
        this.fps.div.style.display = 'none';
    }
    createTooltipPixiApplication(options) {
        this.tooltipApp = new PIXI.Application({
            ...options,
            backgroundAlpha: 0,
            autoDensity: true,
            autoStart: false,
            hello: false
        });
        this.tooltipApp.stage.sortableChildren = true;
        this.tooltipApp.stage.on('childAdded', ()=>{
            if (this.tooltipApp.stage.children.length == 1) this.tooltipApp.start();
        });
        this.tooltipApp.stage.on('childRemoved', ()=>{
            if (this.tooltipApp.stage.children.length != 0) return;
            this.tooltipApp.render();
            this.tooltipApp.stop();
        });
    }
    updateCanvasSettings(options) {
        super.updateCanvasSettings(options);
        const { resolution, antialias, powerPreference } = options;
        if (resolution != undefined) this.tooltipApp.renderer.resolution = resolution;
        if (antialias != undefined) this.tooltipApp.renderer.options.antialias = antialias;
        if (powerPreference != undefined) this.tooltipApp.renderer.options.powerPreference = powerPreference;
        this.tooltipApp.renderer.resize(this.appW, this.appH);
        this.tooltipApp.render();
    }
    static getResolution() {
        const resolution = StorageWrapper.getResolution();
        if (resolution == undefined || resolution == null) return 1;
        const resolutionScale = UIGameResponsiveController.resolutionScale;
        const scaledResolution = resolution * resolutionScale;
        if (!UIUtilsEjsVariables.isUserOnMobile) return scaledResolution;
        const allowedScalesInMobile = [
            0.5,
            1,
            1.5,
            2
        ];
        if (allowedScalesInMobile.includes(resolution)) return resolution;
        return 2;
    }
    builtGame() {
        if (this.app.view.style.display == 'block') return true;
        return false;
    }
    setBackgroundSprite(texture) {
        var _this_backgroundSprite;
        (_this_backgroundSprite = this.backgroundSprite) === null || _this_backgroundSprite === void 0 ? void 0 : _this_backgroundSprite.destroy();
        this.backgroundSprite = new PIXI.Sprite(texture);
        this.backgroundSprite.width = this.app.view.width;
        this.backgroundSprite.height = this.app.view.height;
        this.app.stage.addChildAt(this.backgroundSprite, 0);
    }
    buildCanvas() {
        this.app.view.style.position = 'absolute';
        this.app.view.style.display = 'block';
        this.app.view.style.userSelect = 'none';
        const tooltipCanvas = this.tooltipApp.view;
        tooltipCanvas.style.position = 'absolute';
        tooltipCanvas.style.display = 'block';
        tooltipCanvas.style.userSelect = 'none';
        tooltipCanvas.style.pointerEvents = 'none';
        tooltipCanvas.style.zIndex = UIGameCanvasController.TOOLTIP_CANVAS_Z_INDEX;
    }
    buildDocument() {
        document.body.style.backgroundColor = GameColor.getColor(GameColor.Color.PrimaryBlue0);
        document.body.appendChild(this.app.view);
        document.body.appendChild(this.tooltipApp.view);
        document.body.style.overflow = 'hidden';
        if (document.documentElement != undefined) document.documentElement.style.overflow = 'hidden';
        window.addEventListener('resize', this.resizeScreen);
    }
    syncTooltipCanvas() {
        this.tooltipApp.renderer.resize(this.appW, this.appH);
        this.tooltipApp.view.style.top = this.app.view.style.top;
        this.tooltipApp.view.style.left = this.app.view.style.left;
        this.tooltipApp.view.style.transform = this.app.view.style.transform;
    }
    removeResizeListener() {
        window.removeEventListener('resize', this.resizeScreen);
    }
    buildGame() {
        var _Sentry_getReplay;
        void ((_Sentry_getReplay = Sentry.getReplay()) === null || _Sentry_getReplay === void 0 ? void 0 : _Sentry_getReplay.stop());
        if (this.builtGame()) return;
        this.buildDocument();
        this.buildCanvas();
        this.setupGameContainers();
        this.enableFPSAnalytics();
        this.responsiveController.buildRenderer();
        this.responsiveController.resizeScreen();
        if (this.fps != undefined && !UIUtilsEjsVariables.isProduction) this.fps.div.style.display = 'block';
    }
    // Jan 27, 2021. Jeff: PIXI.App doesn't start loading until you have a child
    // This is a hacky way to start the loading for better UX. There might be a better way?
    kickOffAppLoading() {
        const blankContainer = new PIXI.Container();
        this.uiGameManager.canvasController.app.stage.addChild(blankContainer);
        blankContainer.parent.removeChild(blankContainer);
    }
    addTicker() {
        this.app.ticker.add(()=>{
            var _this_fps;
            const { deltaTime, elapsedMS } = this.app.ticker;
            this.uiGameManager.eventController.gameTick(deltaTime, elapsedMS);
            (_this_fps = this.fps) === null || _this_fps === void 0 ? void 0 : _this_fps.frame();
        }, undefined, PIXI.UPDATE_PRIORITY.NORMAL);
    }
    enableFPSAnalytics() {
        const PROPORTION_OF_CLIENTS_TO_SEND_FPS = 0.05 // 5% of clients will send fps data
        ;
        const isFPSAnalyticsEnabled = Math.random() < PROPORTION_OF_CLIENTS_TO_SEND_FPS;
        if (!isFPSAnalyticsEnabled) return;
        const FPS_ANALYTICS_INTERVAL = TimeUtils.MILLISECONDS * 20 // 20 seconds
        ;
        setInterval(()=>this.sendFPSAnalyticEvent(), FPS_ANALYTICS_INTERVAL);
    }
    sendFPSAnalyticEvent() {
        var _this_fps;
        const fps = (_this_fps = this.fps) === null || _this_fps === void 0 ? void 0 : _this_fps.lastFPS;
        if (fps == undefined) return;
    }
    resizeBackgroundSprite() {
        if (this.backgroundSprite == undefined) return;
        this.backgroundSprite.width = this.app.view.width;
        this.backgroundSprite.height = this.app.view.height;
    }
    constructor(uiGameManager){
        super();
        this.uiGameManager = uiGameManager;
        UIGameCanvasController.setInitialValues();
        this.createPixiApplication();
        this.resizeScreen = ()=>this.responsiveController.resizeScreen();
    }
}
UIGameCanvasController.TOOLTIP_CANVAS_Z_INDEX = '1000';
